import styled from "styled-components";

export const StyledFloatingFrame = styled.div`
    position: fixed;
    right: 10px;
    width: 460px;
    height: 750px;
    z-index: 9999;
    display: block;

    .floating-frame {
        [class*="_floating_frame__content"] {
            overflow: scroll;
        }
    }
`;
